import React from 'react';

function Footer() {
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert('Subscribed!');
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem', marginBottom: '1.25rem' }}>
              <div className="nav-logo-icon" style={{ transform: 'rotate(12deg)' }}>
                <i className="fa-solid fa-cube" style={{ color: '#e8553d', fontSize: '0.75rem', transform: 'rotate(-12deg)' }}></i>
              </div>
              <span className="nav-logo-text">square<span className="accent">prod</span></span>
            </div>
            <p>Engineering digital experiences that drive real business impact. From concept to production.</p>
            <p style={{ fontSize: '0.8rem', color: '#888', marginTop: '0.75rem', lineHeight: 1.6 }}>
              <i className="fa-solid fa-location-dot" style={{ marginRight: '0.4rem', color: '#e8553d' }}></i>Birauta-17, Pokhara, Nepal<br />
              <i className="fa-solid fa-phone" style={{ marginRight: '0.4rem', color: '#e8553d' }}></i>9840337397 | 9826162347<br />
              <i className="fa-solid fa-envelope" style={{ marginRight: '0.4rem', color: '#e8553d' }}></i>safalneupane@squareproduction.com
            </p>
            <div className="footer-tech-icons">
              <i className="fa-brands fa-react"></i>
              <i className="fa-brands fa-node-js"></i>
              <i className="fa-brands fa-python"></i>
              <i className="fa-brands fa-aws"></i>
              <i className="fa-brands fa-figma"></i>
            </div>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>Services</h4>
            <a href="#services" className="ft-link">Web Development</a>
            <a href="#services" className="ft-link">App Development</a>
            <a href="#services" className="ft-link">UI/UX Design</a>
            <a href="#services" className="ft-link">Cloud Architecture</a>
            <a href="#services" className="ft-link">AI Integration</a>
          </div>

          {/* Company */}
          <div className="footer-col">
            <h4>Company</h4>
            <a href="#about" className="ft-link">About</a>
            <a href="#work" className="ft-link">Portfolio</a>
            <a href="#process" className="ft-link">Process</a>
            <button type="button" className="ft-link">Careers</button>
            <button type="button" className="ft-link">Blog</button>
          </div>

          {/* Newsletter */}
          <div className="footer-newsletter">
            <h4 style={{ fontSize: '0.75rem', fontFamily: "'Fira Code', monospace", color: '#999', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '1.25rem' }}>Newsletter</h4>
            <p>Insights on technology, design, and digital strategy. No spam, ever.</p>
            <form className="footer-newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input type="email" placeholder="you@email.com" className="form-field" required style={{ fontSize: '0.875rem' }} />
              <button type="submit" className="btn-ember">
                <i className="fa-solid fa-arrow-right" style={{ fontSize: '0.75rem' }}></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p>&copy; 2026 Square Production. All rights reserved.</p>
          <div className="footer-bottom-links">
            <button type="button" className="ft-link">Privacy</button>
            <button type="button" className="ft-link">Terms</button>
            <button type="button" className="ft-link">Sitemap</button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
